import React, { useEffect, useState } from 'react';
import { Menu, X, Cpu } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About Us',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Our Mission',
    href: '#mission'
  }, {
    name: 'Contact Us',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-[#0a1628]/80 backdrop-blur-md py-3 shadow-lg border-b border-white/5' : 'bg-transparent py-6'}`} data-id="element-60">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-61">
        <a href="#" className="flex items-center gap-2 group relative z-50" data-id="element-62">
          <img src="https://cdn.magicpatterns.com/uploads/vrJu2JQ1pWM588A88QqcHb/4_-_Small.png" alt="Nawat Tech Logo" className="h-10 w-auto transform group-hover:scale-105 transition-transform duration-300" data-id="element-63" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1" data-id="element-64">
          {navLinks.map(link => <a key={link.name} href={link.href} className="relative px-4 py-2 text-gray-300 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide group overflow-hidden rounded-lg hover:bg-white/5" data-id="element-65">
              <span className="relative z-10" data-id="element-66">{link.name}</span>
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#f59e0b] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" data-id="element-67"></span>
            </a>)}
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden relative z-50 p-2 text-white hover:text-[#f59e0b] transition-colors rounded-lg hover:bg-white/5" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-68">
          {isMobileMenuOpen ? <X size={24} data-id="element-69" /> : <Menu size={24} data-id="element-70" />}
        </button>
      </div>

      {/* Mobile Nav Overlay */}
      <div className={`fixed inset-0 bg-[#0a1628]/95 backdrop-blur-xl z-40 md:hidden transition-all duration-500 flex items-center justify-center ${isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`} data-id="element-71">
        <nav className="flex flex-col gap-6 text-center" data-id="element-72">
          {navLinks.map((link, index) => <a key={link.name} href={link.href} className={`text-2xl font-bold text-white hover:text-[#f59e0b] transition-all transform ${isMobileMenuOpen ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{
          transitionDelay: `${index * 100}ms`
        }} onClick={() => setIsMobileMenuOpen(false)} data-id="element-73">
              {link.name}
            </a>)}
        </nav>
      </div>
    </header>;
}